// modifyColumnTargets — VQE-Edit edit-actions that swap the column a DML
// statement writes to, keeping the value:
//   - `modifyAssignmentTarget` — `col = value` in any SET list (top-level
//     UPDATE, a MERGE branch, an INSERT ON CONFLICT / ON DUPLICATE tail) via
//     SR-Edit's `modify-assignment-target`;
//   - `modifyInsertColumn` — one name of an INSERT's explicit column list via
//     `modify-insert-column` (the VALUES cells stay where they are).
// The caller passes the column text as it should appear in SQL (a picked
// catalog column is already delimited per engine; a typed name is verbatim).

import type { ConflictTailTarget } from '../../../../sql-resolver/types/structuralEdit';
import { commitEdit, type CommitEditCtx, type CommitOutcome } from '../commitEdit';
import type { MergeBranchSelector } from './modifyMergeBranch';

/** Which SET list an assignment lives in — neither field ⇒ the top-level UPDATE. */
export type AssignmentListRouter = {
  readonly mergeBranch?: MergeBranchSelector;
  readonly conflictTail?: ConflictTailTarget;
};

export function modifyAssignmentTarget(
  index: number,
  newTarget: string,
  router: AssignmentListRouter,
  ctx: CommitEditCtx,
): Promise<CommitOutcome> {
  return commitEdit(
    {
      op: 'modify-assignment-target',
      index,
      newTarget: newTarget.trim(),
      ...(router.mergeBranch ? { mergeBranch: router.mergeBranch } : {}),
      ...(router.conflictTail ? { tail: router.conflictTail } : {}),
    },
    ctx,
  );
}

export function modifyInsertColumn(
  index: number,
  columnText: string,
  ctx: CommitEditCtx,
): Promise<CommitOutcome> {
  return commitEdit({ op: 'modify-insert-column', index, columnText: columnText.trim() }, ctx);
}
